
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec85d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec85d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2RVy2 = parcelRequire("2RVy2");

var $6WGai = parcelRequire("6WGai");

var $5wcQa = parcelRequire("5wcQa");

var $hMFm7 = parcelRequire("hMFm7");
(0, $2RVy2.Chart).register((0, $2RVy2.Colors), (0, $2RVy2.LineController), (0, $2RVy2.PointElement), (0, $2RVy2.CategoryScale), (0, $2RVy2.LinearScale), (0, $2RVy2.LineElement), (0, $2RVy2.Legend), (0, $5wcQa.default), (0, $hMFm7.default));
(async function() {
    const dataAnxiety = [
        12,
        6.7,
        2.2
    ];
    let maxVal = Math.max(...dataAnxiety);
    let chart = new (0, $2RVy2.Chart)(document.getElementById("graph"), {
        type: "line",
        data: {
            labels: [
                "Pre-program",
                "4-wks",
                "8-wks"
            ],
            datasets: [
                {
                    label: "Mean GAD-7 (Anxiety) score",
                    data: dataAnxiety,
                    fill: false,
                    borderColor: "#FFE600",
                    tension: 0.1,
                    pointRadius: 5,
                    pointBackgroundColor: "#FFE600",
                    pointStyle: "rect",
                    pointRadius: 8
                }
            ]
        },
        options: {
            layout: {
                padding: {
                    right: 10
                }
            },
            maintainAspectRatio: true,
            responsive: true,
            aspectRatio: 5 / 4,
            scales: {
                x: {
                    min: 0,
                    max: 2.5,
                    grid: {
                        display: false
                    },
                    border: {
                        display: false
                    },
                    ticks: {
                        padding: 25,
                        font: {
                            size: 16
                        }
                    }
                },
                y: {
                    min: 0,
                    display: false,
                    ticks: {
                        stepSize: 5,
                        font: {
                            size: 16
                        }
                    },
                    grid: {
                        display: false
                    },
                    border: {
                        display: false
                    }
                }
            },
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        pointStyle: "rect"
                    }
                },
                datalabels: {
                    offset: 7,
                    align: 135,
                    clamp: true,
                    anchor: "end",
                    font: {
                        size: 16
                    }
                },
                annotation: {
                    annotations: {
                        line1: {
                            type: "line",
                            yMin: 0,
                            yMax: 0,
                            borderColor: "grey",
                            borderWidth: 1
                        },
                        lineTop: {
                            type: "line",
                            yMin: maxVal,
                            yMax: maxVal,
                            borderColor: "black",
                            borderWidth: 1,
                            borderDash: [
                                4
                            ]
                        },
                        line4wk: {
                            xMin: 1,
                            yMin: maxVal,
                            xMax: 1,
                            yMax: dataAnxiety[1],
                            type: "line",
                            borderColor: "black",
                            borderWidth: 1,
                            arrowHeads: {
                                end: {
                                    fill: true,
                                    display: true,
                                    width: 5,
                                    length: 5
                                }
                            }
                        },
                        line8wk: {
                            xMin: 2,
                            yMin: maxVal,
                            xMax: 2,
                            yMax: dataAnxiety[2],
                            type: "line",
                            borderColor: "black",
                            borderWidth: 1,
                            arrowHeads: {
                                end: {
                                    fill: true,
                                    display: true,
                                    width: 5,
                                    length: 5
                                }
                            },
                            beforeDraw: ({ chart: chart })=>(0, $6WGai.unclipArea)(chart.ctx),
                            afterDraw: ({ chart: chart })=>(0, $6WGai.clipArea)(chart.ctx, chart.chartArea)
                        },
                        label1: {
                            type: "label",
                            xValue: 1,
                            yValue: (maxVal - dataAnxiety[1]) / 2 + dataAnxiety[1],
                            backgroundColor: "#FFE600",
                            borderColor: "black",
                            borderWidth: 1,
                            borderRadius: 80,
                            content: [
                                `${((maxVal - dataAnxiety[1]) / maxVal * 100).toFixed(1)}%`
                            ],
                            font: {
                                size: 12
                            }
                        },
                        label2: {
                            type: "label",
                            xValue: 2,
                            yValue: (maxVal - dataAnxiety[2]) / 2 + dataAnxiety[2],
                            backgroundColor: "#FFE600",
                            borderColor: "black",
                            borderWidth: 1,
                            borderRadius: 50,
                            beforeDraw: ({ chart: chart })=>(0, $6WGai.unclipArea)(chart.ctx),
                            afterDraw: ({ chart: chart })=>(0, $6WGai.clipArea)(chart.ctx, chart.chartArea),
                            content: [
                                `${((maxVal - dataAnxiety[2]) / maxVal * 100).toFixed(1)}%`
                            ],
                            font: {
                                size: 12
                            }
                        }
                    }
                }
            }
        }
    });
})();


//# sourceMappingURL=index_anxiety.822c3683.js.map
